import { faqData } from '@/mocks/homeData';

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
            吃瓜指南
          </h2>
          <p className="text-sm text-foreground-500">关于平台的常见问题，帮助你更好地吃瓜</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqData.map((item) => (
            <details key={item.id} className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors list-none">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4">{item.question}</h3>
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform" />
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}